import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);
  const [lead, ...rest] = featured;

  if (!lead) return null;

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading eyebrow="热门曝光" title="被转发最多的几篇档案" />
          <Link
            to="/archives"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
          >
            查看全部档案
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-12">
          <article className="group relative overflow-hidden rounded-lg lg:col-span-7">
            <Link to={`/archives/${lead.slug}`} className="block h-full">
              <div className="h-72 w-full lg:h-[420px]">
                <img
                  src={lead.cover}
                  alt={lead.title}
                  title={`${lead.title} - 缅北黑料内幕档案`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                <span className="inline-flex items-center rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  {lead.categoryName}
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-200 sm:block">
                  {lead.excerpt}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-300">
                  <span>{lead.date}</span>
                  <span>{lead.readTime}</span>
                  <span>{lead.author}</span>
                </div>
              </div>
            </Link>
          </article>

          <div className="flex flex-col gap-4 lg:col-span-5">
            {rest.slice(0, 3).map((item) => (
              <article
                key={item.slug}
                className="group flex flex-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:p-4"
              >
                <Link to={`/archives/${item.slug}`} className="flex flex-1 gap-4">
                  <div className="h-24 w-24 shrink-0 overflow-hidden rounded-md md:h-28 md:w-28">
                    <img
                      src={item.cover}
                      alt={item.title}
                      title={`${item.title} - 缅北黑料内幕档案`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col">
                    <span className="text-xs font-medium text-secondary-700">{item.categoryName}</span>
                    <h3 className="mt-1.5 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                      {item.title}
                    </h3>
                    <span className="mt-auto pt-2 text-xs text-foreground-500">
                      {item.date} · {item.readTime}
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}